import React, { Component } from "react";
import {Grid, Avatar, Hidden, Modal, Select} from "@material-ui/core";
import Fab from "@material-ui/core/Fab/Fab";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import {
  primaryColor,
  textBlack,
  textPrimary,
  webFont
} from "../../config/theme";
import { compose, graphql } from "react-apollo";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import { UPDATE } from "../../graphql/mutations/user";
import { connect } from "react-redux";
import axios from "axios";
import ResetPasswordDrawer from "./ResetPasswordDrawer";
import { NotificationManager } from "react-notifications";
import CircularProgress from "@material-ui/core/CircularProgress";
import {getChef, getUser} from "../../redux/user";
import Icon from '@material-ui/core/Icon';
import {stateList} from "../../config/constants";
import ImageCropper from "../FileUpload/image-cropper";
import { IMAGE_API } from "../../config/constants";
import {imageSizeValidator} from "../FileUpload/image-validator";
import {validateAddress} from "../../utils/address-validation";

const defaultChefImg = "/images/simple-chef.webp";
const tick = "/images/tick.webp";

class EditProfile extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      selectedImage: null,
      initialState: {
        aboutme: "",
        firstName: "",
        lastName: "",
        cellPhone: "",
        emailId: "",
        profilePic: "",
        username: "",
        address: {
          street1: "",
          street2: "",
          city: "",
          state: "",
          zip: ""
        }
      },
      errors: {
        aboutme: "",
        firstName: "",
        lastName: "",
        cellPhone: "",
        username: "",
        emailId: "",
        address: {
          street1: "",
          street2: "",
          city: "",
          state: "",
          zip: ""
        }
      },
      editAddress: false,
      loading: false,
      uploadedData: null,
      openPasswordDrawer: false,
      uploading: false
    };
  }

  componentDidMount() {
    const { userId, dispatch, isChef } = this.props;

    if(!isChef)
    dispatch(getUser(userId));
    else
    dispatch(getChef(userId));

    this.updateUserState()
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { chef, diner } = nextProps;
    let user = nextProps.isChef ? chef : diner;

    if(user)
      this.setState( {
        initialState: {
          aboutme: user.story,
          firstName: user.firstName,
          lastName: user.lastName,
          cellPhone: user.cellPhone,
          emailId: user.emailId,
          profilePic: user.profilePic,
          username: user.username || '',
          address: {
            street1: user.address.street1,
            street2: user.address.street2,
            city: user.address.city,
            state: user.address.state,
            zip: user.address.zip
          }
        },
      });
  }

  updateUserState(){
    const { chef, diner } = this.props;
    let user = this.props.isChef ? chef : diner;

    if(user)
      this.setState( {
        initialState: {
          aboutme: user.story,
          firstName: user.firstName,
          lastName: user.lastName,
          cellPhone: user.cellPhone,
          emailId: user.emailId,
          profilePic: user.profilePic,
          username: user.username || "",
          address: {
            street1: user.address.street1,
            street2: user.address.street2,
            city: user.address.city,
            state: user.address.state,
            zip: user.address.zip
          }
        },
      });
  }

  handleChange = (name, e) => {
    let errors = this.state.errors;
    let re = /^[a-zA-Z ]*$/;
    const { chef } = this.props;
    const { diner } = this.props;
    const user = this.props.isChef ? chef : diner;
    let { initialState } = this.state;

    switch (name) {
      case "aboutme":
        initialState.aboutme = e.target.value;
        break;

      case "username":
        if(e.target.value == null || e.target.value === '') {
          errors.username = "Username is mandatory";
        } else {
          errors.username = "";
        }
        initialState.username = e.target.value ? e.target.value.replace(/ /g,'-') : '';
        break;

      case "firstName":

        if(e.target.value == null || e.target.value === '') {
          errors.firstName = "First Name is mandatory";
        }
         else if (!re.test(e.target.value)) {
          errors.firstName = "Please enter a valid name";
        } else if (e.target.value.length < 2) {
          errors.firstName = "Minimum 2 letters are required";
        } else {
          errors.firstName = "";
        }
        initialState.firstName = e.target.value;
        break;
      case "lastName":
        if(e.target.value == null || e.target.value === '') {
          errors.lastName = "Last Name is mandatory";
        }
        else if (!re.test(e.target.value)) {
          errors.lastName = "Please enter a valid name";
        } else {
          errors.lastName = "";
        }
        initialState.lastName = e.target.value ;
        break;
      case "cellPhone":
        const val = e.target.value;
        if (val != "" && isNaN(val)) {
          errors.cellPhone = "Please enter a valid phone number";
        } else if (val.length !== 10) {
          errors.cellPhone = "Must be 10 digits";
        } else {
          errors.cellPhone = "";
        }
        initialState.cellPhone = e.target.value;

        break;
      case "emailId":
        let value = e.target.value;
        let emailIdValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if (!emailIdValid) {
          errors.emailId = "Please enter a valid email";
        } else {
          errors.emailId = "";
        }
        initialState.emailId = e.target.value;
        break;

      case "city":
        if (e.target.value === '' || e.target.value === null) {
           errors.address.city = "Please enter a city";
        }else if (!re.test(e.target.value.trim())) {
          errors.address.city = "City shouldn't contain special characters";
        } else {
          errors.address.city = "";
        }

        initialState.address.city = e.target.value.replace(/[^a-zA-Z ]/g, '');
        break;

      case "state":
        if (e.target.value === '' || e.target.value === null) {
          errors.address.state = "Please select a state";
        } /*else if (!re.test(e.target.value)) {
          errors.address.state = "State Shouldn't contain Special Characters";
        } else if (e.target.value.length !== 2) {
          errors.address.state = "Mention 2 letter state code";
        }*/ else {
          errors.address.state = "";
        }

        initialState.address.state =  e.target.value;
        break;

      case "zip":
        value = e.target.value;
        if (
          (value.length !== 5) ||
          (e.target.value != "" && isNaN(e.target.value))
        ) {
          errors.address.zip = "Please enter a valid zip code";
        } else {
          errors.address.zip = "";
        }
        initialState.address.zip = e.target.value.replace(/[^0-9]/g, '');

        break;
      case "street1":
        initialState.address.street1 = e.target.value;
        const poBoxRegex = /^(?!.*(?:(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(box|bin)[-.\s]*)|.*((p |post)[-.\s]*(box|bin)[-.\s]*)))).*$/i;
        if (e.target.value === '' || e.target.value === null) {
          errors.address.street1 = "Please enter a physical address";
        } //else if (e.target.value.startsWith("PO") || e.target.value.startsWith("P.O.") || e.target.value.startsWith("po") || e.target.value.startsWith("p.o.")) {
        else if (!poBoxRegex.test(e.target.value)) {
          errors.address.street1 = "Please enter a physical address";
        } else {
          errors.address.street1 = "";
        }
        break;
      case "street2":
        initialState.address.street2 = e.target.value;
        break;
      default:
        return;
    }

    this.setState({
      initialState
    });

    this.setState({ errors: { ...this.state.errors, ...errors } });
  };

  updateUser(){
      const { updateUser, isChef } = this.props;
      const { updateChef, dispatch, userId } = this.props;
      const { initialState } = this.state;

          let payload = {
            profilePic: this.state.uploadedData
                ? this.state.uploadedData.data.url
                : "",
          };

        /*  if(isChef){
            payload.userId=userId;
            updateChef({
              variables: {chef: payload}
            })
                .then(res => {
                  console.log(res);
                  NotificationManager.error("Profile Image Updated");
                  initialState.profilePic=payload.profilePic;
                  this.setState({initialState: initialState})
                })
                .catch(err => {
                  console.log(err);

                  console.log(JSON.parse(JSON.stringify(err)));
                });
          }else {*/
            payload.id=userId;
            updateUser({
              variables: {user: payload}
            })
                .then(res => {
                  NotificationManager.info("Profile image updated");
                  initialState.profilePic=payload.profilePic;
                  this.setState({initialState: initialState})

                  if(!isChef)
                    dispatch(getUser(userId));
                  else
                    dispatch(getChef(userId));

                })
                .catch(err => {
                  console.log(JSON.parse(JSON.stringify(err)));
                  NotificationManager.error("Image not saved");
                });
          //}
  }

  submitDetail = async event => {
    event.preventDefault();

    const { updateUser, isChef } = this.props;
    const { updateChef, dispatch, userId } = this.props;

    let formData = event.target.elements;
    if(!!formData.street1.value && !!formData.city.value && !!formData.zip.value) {
      if (this.validateDetails()) {
        this.setState({ editAddress: false });

        if (formData.cellPhone.value.length > 0) {
          if (formData.cellPhone.value.length !== 10) {
            NotificationManager.error('Must be at least 10 digits', 'Cell Phone');
            return;
          }
        }


        let payload = {
          id: this.props.userId,
          emailId: formData.emailId.value,
          firstName: formData.firstName.value,
          lastName: formData.lastName.value,
          cellPhone: formData.cellPhone.value,
          address: {
            street1: formData.street1.value,
            street2: formData.street2.value,
            city: formData.city.value,
            state: this.state.initialState.address.state,
            zip: formData.zip.value,
            country: "US"
          },
          profilePic: this.state.uploadedData
              ? this.state.uploadedData.data.url
              : "",
          zipcode: formData.zip.value
        };

        const addrStr = payload.address.street1 + ' ' + payload.address.street2 + ', ' + payload.address.city + ', ' + payload.address.state + ' ' + payload.address.zip;
        const response = await validateAddress(addrStr, payload.address.city);

        if (response.length) {
          NotificationManager.error('The address is invalid. Please input a valid one.', 'Address', 4500);
          this.setState({ editAddress: true });
          return;
        }

        updateUser({
          variables: {user: payload}
        })
            .then(res => {
              NotificationManager.info("All details are saved");
              if (isChef){
                dispatch(getChef(userId));
              } else {
                dispatch(getUser(userId));
              }

            })
            .catch(err => {
              console.log(JSON.parse(JSON.stringify(err)));
              NotificationManager.error("Details are not saved");
            });

        if (isChef) {
          if (!formData.username.value) {
            NotificationManager.error('Username is mandatory', 'Edit Profile');
            return;
          }
          let chefPayload = {
            userId: this.props.userId,
            username: formData.username.value,
            address: {
              street1: formData.street1.value,
              street2: formData.street2.value,
              city: formData.city.value,
              state: this.state.initialState.address.state,
              zip: formData.zip.value,
              country: "US"
            }
          };

          updateChef({
            variables: {chef: chefPayload}
          })
              .then(res => {

                dispatch(getUser(userId));
              })
              .catch(err => {
                console.log(err);

                console.log(JSON.parse(JSON.stringify(err)));
              });
        }
      } else{
          NotificationManager.error("Enter valid value.");
      }
    } else{
      NotificationManager.error("Please enter mandatory fields");
    }
  };

  validateDetails() {
    let stateErrors = this.state.errors;
    let validated = true;

    for (let key in stateErrors) {
      if (stateErrors[key]) {
        if (key == "address") {
          for (let addressKey in stateErrors[key]) {
            if (stateErrors[key][addressKey]) {
              validated = false;
            }
          }
        } else {
          validated = false;
        }
      }
    }
    return validated;
  }

  handleClick = e => {
    this.refs.fileUploader.click();
  };

  toggleLoginDrawer = () => {
    this.setState({ openPasswordDrawer: !this.state.openPasswordDrawer });
  };

  closeLoginDrawer = () => {
    this.setState({ openPasswordDrawer: false });
  };

  setLoading = loading => {
    this.setState({ loading });
  };

  uploadAPI = files => {
    const { fileType } = this.props;
    let formData = new FormData();
    formData.append("imgfile", files);
    formData.append("fileType", fileType);
    this.closeModal();
    const token = window.localStorage.getItem("ccZestyAuthToken");
    this.setLoading(true);
    this.setState({ uploading: true });
    axios
      .post(`${IMAGE_API}/img-upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${window.localStorage.getItem("ccZestyAuthToken")}`
        }
      })
      .then(uploadedData => {
        this.setState({ uploadedData, uploading: false }, () => {
          this.updateUser();
        });
      })
      .catch(err => {
        console.log(err);
        this.setState({ uploading: false });
      });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  imageAfterValidation = (files) => {
    const file = files[0];
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.setState({ selectedImage: reader.result, isModalOpen: true });
    }, false);
    reader.readAsDataURL(file);
  };

  render() {
    const { chef } = this.props;
    const { diner } = this.props;
    const { initialState } = this.state;
    let user = this.props.isChef ? chef : diner;

    if (initialState) {
      if (initialState.address) {
        if (!initialState.address.state) {
          initialState.address.state = '';
        }
      }
    }

    let isCreated = user && !!user.id;
    let address =
      isCreated && user.address.street1
        ? `${user.address.street1} ${user.address.street2} ${
            user.address.city
          } ${user.address.state} ${user.address.zip}`
        : `${initialState.address.street1} ${initialState.address.street2} ${
            initialState.address.city
          } ${initialState.address.state} ${initialState.address.zip}`;

    let profileUrl = user ? user.profilePic ? user.profilePic : defaultChefImg : defaultChefImg;

    return (
      <div>
        <form onSubmit={this.submitDetail} style={{marginTop: 5}}>
          <Grid container spacing={16} style={{zIndex:-1 }}>
            <Grid item lg={2} md={3} sm={3} xs={6}>
              <div onClick={this.handleClick}>
                {!this.state.uploading && (
                    <div >
                      <div>
                          <Avatar
                              src={profileUrl}
                              alt="Image not available"
                              style={styles.avatarImg}
                          />
                      </div>

                      <div style={styles.editImg}>
                        <Icon data-test-id={"editbtn"} style={{color:primaryColor}}>edit</Icon>
                      </div>
                    </div>
                )}
                {this.state.uploading && <CircularProgress color={"primary"} />}
                <input
                  type="file"
                  ref="fileUploader"
                  style={{ display: "none" }}
                  onChange={data => {
                    const files = data.target.files;
                    imageSizeValidator(files, this.imageAfterValidation, this.closeModal)
                  }}
                />
              </div>
            </Grid>
            <Grid item md={6} sm={9} xs={6} style={{ display: 'flex', alignItems: 'center', position: 'relative'}}>
              <p style={styles.userName}>
                { user && user.firstName+" "+ user.lastName}
              </p>
              {user && user.verified && <div style={{ position: 'absolute', top: 5, left: -25 }}>
                <img src={tick} alt="Verified Chef" style={styles.tick} />
              </div>}
            </Grid>
            <Grid item md={3} />

            <Grid item md={6} xs={12}>
              <InputLabel style={styles.ftText}>FIRST NAME</InputLabel>

              <Input
                name={"firstName"}
                placeholder={"Jane"}
                label={"FIRST NAME"}
                type={"text"}
                value={initialState.firstName
                }
                onChange={e => {
                  this.handleChange("firstName", e);
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.firstName}
              </FormHelperText>
            </Grid>
            <Grid item md={6} xs={12}>
              <InputLabel style={styles.ftText}>LAST NAME</InputLabel>

              <Input
                name={"lastName"}
                placeholder={"Doe"}
                label={"LAST NAME"}
                type={"text"}
                value={ initialState.lastName
                }
                onChange={e => {
                  this.handleChange("lastName", e);
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.lastName}
              </FormHelperText>
            </Grid>
            {this.props.isChef && <Grid item md={6} xs={12}>
              <InputLabel style={styles.ftText}>USERNAME</InputLabel>

              <Input
                name={"username"}
                placeholder={"jane-doe"}
                label={"USERNAME"}
                type={"text"}
                value={initialState.username}
                readOnly={initialState.username ? true : false}
                onChange={e => {
                  this.handleChange("username", e);
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.username}
              </FormHelperText>
            </Grid>}
            <Grid item md={6} xs={12}>
              <InputLabel style={styles.ftText}>Cell Phone</InputLabel>

              <Input
                name={"cellPhone"}
                placeholder={"123 4567 890"}
                label={"CELL PHONE"}
                type={"text"}
                value={initialState.cellPhone
                }
                onChange={e => {
                  this.handleChange("cellPhone", e);
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.cellPhone}
              </FormHelperText>
            </Grid>
            <Grid item md={6} xs={12}>
              <InputLabel style={styles.ftText}>EMAIL</InputLabel>

              <Input
                name={"emailId"}
                placeholder={"hello@cuisinecrafters.net"}
                label={"emailId"}
                type={"text"}
                value={initialState.emailId
                }
                onChange={e => {
                  this.handleChange("emailId", e);
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text" style={styles.error}>
                {this.state.errors.emailId}
              </FormHelperText>
            </Grid>
            <Grid item md={6} xs={12}>
              <div
                style={
                  this.state.editAddress
                    ? styles.displayNone
                    : styles.displayBlock
                }
              >
                <InputLabel style={styles.ftText}>ADDRESS</InputLabel>

                <Input
                  name={"address"}
                  placeholder={"address"}
                  label={"ADDRESS"}
                  type={"text"}
                  value={address.indexOf('null') > -1 ? "Add address" : address}
                  style={styles.inputText}
                  onClick={() => {
                    this.setState({ editAddress: true });
                  }}
                />
              </div>
            </Grid>
            {!this.props.isChef && <Grid item md={6} />}
            <Grid item md={6} xs={12}>
              <div
                style={
                  !this.state.editAddress
                    ? styles.displayNone
                    : styles.displayBlock
                }
              >
                <InputLabel style={styles.ftText}>STREET</InputLabel>

                <Input
                  name={"street1"}
                  placeholder={"Physical address"}
                  type={"text"}
                  value={ initialState.address.street1}
                  onChange={e => {
                    this.handleChange("street1", e);
                  }}
                  style={styles.inputText}
                />
                <FormHelperText id="component-error-text" style={styles.error}>
                  {this.state.errors.address.street1}
                </FormHelperText>
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div
                style={
                  !this.state.editAddress
                    ? styles.displayNone
                    : styles.displayBlock
                }
              >
                <InputLabel style={styles.ftText}>
                  APARTMENT/SUITE ETC.
                </InputLabel>

                <Input
                  name={"street2"}
                  placeholder={"Apt 000"}
                  type={"text"}
                  value={initialState.address.street2}
                  onChange={e => {
                    this.handleChange("street2", e);
                  }}
                  style={styles.inputText}
                />
                <FormHelperText id="component-error-text" style={styles.error}>
                  {this.state.errors.address.street2}
                </FormHelperText>
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div
                style={
                  !this.state.editAddress
                    ? styles.displayNone
                    : styles.displayBlock
                }
              >
                <InputLabel style={styles.ftText}>CITY</InputLabel>

                <Input
                  name={"city"}
                  placeholder={"ex: Los Angeles"}
                  type={"text"}
                  value={initialState.address.city}
                  onChange={e => {
                    this.handleChange("city", e);
                  }}
                  style={styles.inputText}
                />
                <FormHelperText id="component-error-text" style={styles.error}>
                  {this.state.errors.address.city}
                </FormHelperText>
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div
                style={
                  !this.state.editAddress
                    ? styles.displayNone
                    : styles.displayBlock
                }
              >
                <InputLabel style={styles.ftText}>STATE</InputLabel>
                {/*<Input
                  name={"state"}
                  placeholder={"state"}
                  type={"text"}
                  value={initialState.address.state}
                  onChange={e => {
                    this.handleChange("state", e);
                  }}
                  style={styles.inputText}
                />*/}
                <Select
                  inputProps={{MenuProps: {disableScrollLock: true}}}
                  data-test-id={"chefstate-id"}
                  native
                  value={initialState.address.state}
                  onChange={(ev) => this.handleChange("state", ev)}
                  style={styles.inputText}
                >
                  <option value="">Select State</option>
                  {stateList.map(st => (
                    <option value={st.id} key={st.id} style={{ fontFamily: 'Poppins'}}>{st.id}</option>
                  ))}
                </Select>
                <FormHelperText id="component-error-text" style={styles.error}>
                  {this.state.errors.address.state}
                </FormHelperText>
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div
                style={
                  !this.state.editAddress
                    ? styles.displayNone
                    : styles.displayBlock
                }
              >
                <InputLabel style={styles.ftText}>ZIP CODE</InputLabel>

                <Input
                  name={"zip"}
                  placeholder={"12345"}
                  type={"text"}
                  value={initialState.address.zip}
                  onChange={e => {
                    this.handleChange("zip", e);
                  }}
                  style={styles.inputText}
                />
                <FormHelperText id="component-error-text" style={styles.error}>
                  {this.state.errors.address.zip}
                </FormHelperText>
              </div>
            </Grid>
            <Grid item md={6} />
            <Grid data-test-id={"changepwd"} item md={6} xs={12} style={{marginTop: 24}}>
              <Fab
                variant={"extended"}
                type="button"
                style={styles.changPasswordBtn}

                onClick={() => {
                  this.setState({ openPasswordDrawer: true });
                }}
              >
                Change password
              </Fab>
            </Grid>
            <Grid
              container
              alignItems="center"
              justify="flex-end"
              direction="row"
              textAlign="right"
            >
              <Hidden smUp>
                <Grid item xs={2} />
                <Grid item xs={8}>
                  <Fab
                    data-test-id={"subeditprof"}
                    variant={"extended"}
                    disabled={this.props.loading}
                    type="submit"
                    style={styles.submitButton}
                  >
                    Save
                  </Fab>
                </Grid>
              </Hidden>
              <Hidden xsDown>
                <Grid item xs={2} />
                <Grid className="edit-submit-btn" item xs={8} md={9} lg={8} style={{ textAlign: "right", marginTop: 40, marginRight: 10   }}>

                  <Fab
                    data-test-id={"subeditprof"}
                    variant={"extended"}
                    disabled={this.props.loading}
                    type="submit"
                    style={styles.submitButton}
                  >
                    Save
                  </Fab>
                </Grid>
                <Grid item xs={1} />
              </Hidden>
            </Grid>
          </Grid>
        </form>
        <ResetPasswordDrawer
          openPasswordDrawer={this.state.openPasswordDrawer}
          closeLoginDrawer={this.closeLoginDrawer}
          toggleLoginDrawer={this.toggleLoginDrawer}
          history={this.props.history}
        />
        <Modal
          open={this.state.isModalOpen}
          onClose={this.closeModal}
          aria-labelledby="image-cropper"
          aria-describedby="image-cropper-modal"
        >
          <ImageCropper img={this.state.selectedImage} uploadImage={this.uploadAPI} />
        </Modal>
      </div>
    );
  }
}

const mapSateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    diner: state.user.diner,
    chef: state.user.chef
  };
};
const UserProfileWithData = compose(
  graphql(UPDATE, { name: "updateUser" }),
  graphql(UPDATE_CHEF, { name: "updateChef" })
)(EditProfile);
const UserUpdateProfile = connect(mapSateToProps)(UserProfileWithData);

export default UserUpdateProfile;

const styles = {

  avatarImg: {
    width: "86px",
    height: "86px",
  },

  editImg: {
    float:'right',
    border: `1px solid ${primaryColor}`,
    borderRadius: '50%',
    height:'25px',
    marginLeft:'55px',
    marginTop:'-25px',
    position:'absolute',
    backgroundColor:'white',
    alignItems:'center',
    width:'25px',
    padding: '3px',
  },

  userName: {
    fontFamily: webFont,
    fontSize: "30px",
    color: textBlack,
    fontWeight: 500,
    paddingLeft: 0,
    textAlign: "left",
    margin: 0,
  },

  ftText: {
    fontFamily: webFont,
    fontSize: "15px",
    color: textBlack,
    marginLeft: 80,
    fontWeight: 500,
    marginTop:30
  },
  frlabel: {
    fontFamily: webFont,
    fontSize: "20px",
    color: textPrimary,
    marginLeft: 80,
    fontWeight: 500,
    marginBottom: 30,
    marginTop: 30,
    '&:hover': {
      cursor: 'pointer',
    }
  },
  inputText: {
    fontFamily: webFont,
    fontSize: "18px",
    width: "80%",
  },
  setFont: {
    fontFamily: webFont
  },

  showBtn: {
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20
  },
  displayBlock: {
    display: "block"
  },
  displayNone: {
    display: "none"
  },
  error: { fontSize: 12, color: "red", fontFamily: webFont },
  submitButton: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    minWidth: 204,
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    boxShadow: "none",
  },
  changPasswordBtn: {
    borderRadius: 25,
    color: primaryColor,
    border: "none",
    width: "auto",
    backgroundColor: "white",
    height: "auto",
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    boxShadow: "none",
    fontSize: "20px",
    justifyContent: "flex-start",
    padding: 0,
    opacity: '0.8',
  },
  tick: {
    width: 28,
    height: 28,
  }
};
